import React, { useState } from 'react';
import './ProjectManager.css';

function ProjectManager({ projects, onAddProject, onDeleteProject }) {
  const [newProjectName, setNewProjectName] = useState('');
  const [error, setError] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);

  const handleAddProject = (e) => {
    e.preventDefault();
    
    if (!newProjectName.trim()) {
      setError('Nazwa klienta nie może być pusta');
      return;
    }

    if (projects.includes(newProjectName.trim())) {
      setError('Klient o tej nazwie już istnieje');
      return;
    }

    onAddProject(newProjectName.trim());
    setNewProjectName('');
    setError('');
  };

  const handleDeleteClick = (projectName) => {
    setProjectToDelete(projectName);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    if (projectToDelete) {
      onDeleteProject(projectToDelete);
      setShowDeleteModal(false);
      setProjectToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setProjectToDelete(null);
  };

  return (
    <div className="project-manager">
      <form onSubmit={handleAddProject} className="add-project-form">
        <div className="form-group-inline">
          <input
            type="text"
            value={newProjectName}
            onChange={(e) => {
              setNewProjectName(e.target.value);
              setError('');
            }}
            placeholder="Nazwa nowego klienta"
            className="project-input"
          />
          <button type="submit" className="add-project-button">Dodaj klienta</button>
        </div>
        {error && <div className="error-message">{error}</div>}
      </form>

      <div className="projects-list">
        <h4>Lista klientów ({projects.length})</h4>
        {projects.length === 0 ? (
          <p className="no-projects">Brak klientów</p>
        ) : (
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-item">
                <span className="project-name">{project}</span>
                <button
                  onClick={() => handleDeleteClick(project)}
                  className="delete-project-button"
                  title="Usuń klienta"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal potwierdzenia usunięcia projektu */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={handleDeleteCancel}>
          <div className="modal-content delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Potwierdź usunięcie</h3>
              <button className="modal-close" onClick={handleDeleteCancel}>×</button>
            </div>
            <div style={{ padding: '32px' }}>
              <p>
                Czy na pewno chcesz usunąć klienta <strong>"{projectToDelete}"</strong>?
              </p>
              <p className="delete-warning">
                ⚠️ Wszyscy użytkownicy przypisani do tego klienta zostaną odpięci.
              </p>
              <div className="modal-actions">
                <button className="btn-cancel" onClick={handleDeleteCancel}>
                  Anuluj
                </button>
                <button className="btn-delete" onClick={handleDeleteConfirm}>
                  Usuń
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectManager;



